import React, { Component } from 'react';

// import { connect } from 'react-redux';
// import { asyncConnect } from 'redux-connect';
import * as kalturaAction from './actions';

import serverClientUtil from '../../utils/serverClientUtil';

import ReactKalturaResumableJs from './ReactKalturaResumableJs';

// const KALTURA_LOGIN = '/service/user/action/loginByLoginId';        // eslint-disable-line no-unused-vars
// const KALTURA_CATEGORY_LIST = '/service/categoryentry/action/list'; // eslint-disable-line no-unused-vars
const KALTURA_START_SESSION = '/service/session/action/start';       // eslint-disable-line no-unused-vars

export default class KalturaFileUpload extends Component {
  constructor() {
    super();
    this.state = {
      uploader: '',
      ks: '',
    };
  }
  onFileSuccess = (data) => {
    if (typeof this.props.onFileSuccess === 'function') {
      this.props.onFileSuccess(data);
    }
  }
  renderUploader = () => {
    if (this.state.uploader.trim().length === 0) {
      kalturaAction.getKalturaSession().then((response) => {
        const result = response.body;
        if (result && result.code && result.message) {
          alert(result.message);   // Error
        } else {
          this.setState({
            uploader: result,
          });
        }
      });
    }
  }

  getsession = () => {
    if (this.state.uploader.trim().length === 0) {
      kalturaAction.getKalturaStartSession().then((response) => {
        const result = response.body;
        if (result && result.code && result.message) {
          alert(result.message);   // Error
        } else {
          this.setState({
            uploader: result,
          });
        }
      });
    }
  }
  
  UNSAFE_componentWillMount = () => {
    this.getsession();
  }

  render() {
    // this.renderUploader();   
    return (
      <div id="uploaderContainer">
        <ReactKalturaResumableJs
          server={serverClientUtil.getKalturaURL()}
          ks={this.state.uploader}
          uploaderID="myKalturaUploader"
          onFileSuccess={this.onFileSuccess}
          onFileRemoved={this.onFileRemoved}
          onError={this.onError}
          maxFileSize={3145728} // 3 MB file
          minFileSize={131072} // 128 KB file
          // categories={document.querySelector('#categories option:checked').value}
          maxFiles={1}
          textLabel={this.props.textLabel}
          fileAccept={this.props.fileAccept}    // "image/*"
          filetypes={['jpg', 'png', 'bmp', 'jpeg']}
          onFileAddedError={this.props.onFileAddedError}
          onMaxFileSizeErrorCallback={this.props.onMaxFileSizeErrorCallback}
          onMinFileSizeErrorCallback={this.props.onMinFileSizeErrorCallback}
          maxFilesErrorCallback={function () {
            alert('Max Files: 1');
          }}
        />
      </div>
    );
  }
}
